import { ko } from 'date-fns/locale/ko';
import moment from 'moment';
import { useEffect, useRef, useState } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import { useSearchParams } from 'react-router-dom';
import { postMAIAB010, postMAIAB010deleteCoupon, postMAIAB010Download } from '../../../services/Api';
import CheckGroup from '../../../shared/components/CheckGroup';
import momentDate from '../../../shared/components/MomentDate';
import Pagination from '../../../shared/components/Pagination';
import SideMenu from '../../../shared/components/SideMenu';
import { MENU_PAYMENT, MESSAGE } from '../../../shared/constants/app';
import { formatDate, formatNumberWithCommas } from '../../../utils';
registerLocale('ko', ko);

const MAIAB010 = () => {
    const startDateRef = useRef();
    const endDateRef = useRef();
    const [data, setData] = useState([]);
    const [pages, setPages] = useState({});
    const [searchCondition, setSearchCondition] = useState('DE_MemberID');
    const [keyword, setKeyword] = useState('');
    const [dateRate, setDateRate] = useState('');
    const [searchParams, setSearchParams] = useSearchParams();
    const page = Number(searchParams.get('page')) || 1;
    const [checkedValues, setCheckedValues] = useState({});

    const currentYear = moment().year();
    const years = Array.from({ length: 30 }, (_, i) => currentYear - i);
    const [selectedYear, setSelectedYear] = useState(moment().year());
    const [selectedMonth, setSelectedMonth] = useState(moment().month() + 1);
    const [isDownloading, setIsDownloading] = useState(false);

    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');

    const getSearchCondition = (e) => {
        setSearchCondition(e.target.value);
    };

    const inputChange = (e) => {
        setKeyword(e.target.value);
    };

    const handleDateRange = (e) => {
        const valueRangeDate = e.target.getAttribute('value-date-range');
        setDateRate(valueRangeDate);
        const today = moment().format('YYYY-MM-DD');
        const dateMoment = momentDate(today, valueRangeDate);
        setStartDate(dateMoment);
        setEndDate(today);
    };

    const handleDateChange = (date, name) => {
        setDateRate('');
        if (name === 'startDate') {
            setStartDate(date);
        } else if (name === 'endDate') {
            setEndDate(date);
        }
    };

    const getListData = (currentPage = page) => {
        const startDateFormated = startDate ? moment(startDate).format('YYYY-MM-DD') : null;
        const endDateFormated = endDate ? moment(endDate).format('YYYY-MM-DD') : null;
        postMAIAB010({
            page: currentPage,
            searchCondition,
            keyword: keyword?.trim(),
            startDate: startDateFormated,
            endDate: endDateFormated,
            options: checkedValues,
        })
            .then(({ data }) => {
                setData(data.data);
                setPages(data.info);
            })
            .catch((error) => {
                console.error(error);
            });
    };

    const clickSearch = () => {
        setSearchParams({ page: 1 });
        getListData(1);
    };

    const handleDelete = (deMemberID, couponNum) => {
        const isConfirm = window.confirm(MESSAGE.confirm.delete);
        if (isConfirm) {
            postMAIAB010deleteCoupon({ deMemberID, couponNum })
                .then(() => {
                    getListData();
                    window.alert(MESSAGE.notify.deleteSuccess);
                })
                .catch((error) => {
                    console.log(error);
                    window.alert(MESSAGE.notify.deleteError);
                });
        }
    };

    const handleYearChange = (e) => {
        setSelectedYear(Number(e.target.value));
    };

    const handleMonthChange = (e) => {
        setSelectedMonth(Number(e.target.value));
    };

    const onDownload = async () => {
        try {
            setIsDownloading(true);

            // Calculate first and last day of selected month
            const startDate = moment(`${selectedYear}-${selectedMonth}-01`).format('YYYY-MM-DD');
            const endDate = moment(`${selectedYear}-${selectedMonth}-01`).endOf('month').format('YYYY-MM-DD');

            const { data } = await postMAIAB010Download('xlsx', startDate, endDate);

            // Create and trigger download
            const url = window.URL.createObjectURL(new Blob([data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute(
                'download',
                `교환쿠폰_발급현황_${selectedYear}${String(selectedMonth).padStart(2, '0')}.xlsx`,
            );
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            console.error('Download error:', error);
            window.alert('다운로드 중 오류가 발생했습니다.');
        } finally {
            setIsDownloading(false);
        }
    };

    const clickReset = () => {
        setSearchParams('');
        setStartDate('');
        setEndDate('');
        setDateRate('');
        setKeyword('');
        setSearchCondition('DE_MemberID');
        setCheckedValues({});
    };
    useEffect(() => {
        getListData();
        // eslint-disable-next-line
    }, [page]);

    // const handleCheckboxChange = (e) => {
    //     const { name, value, checked } = e.target;
    //     setCheckedValues((checkedValues) => getCheckBoxValues(checkedValues, name, value, checked));
    // };
    const handleCheckboxChange = (e) => {
        const { name, value, checked } = e.target;

        setCheckedValues((prev) => {
            let newValues = [...(prev[name] || [])];

            if (checked) {
                if (value === 'ALL') {
                    newValues = ['ALL'];
                } else {
                    newValues = newValues.filter((v) => v !== 'ALL');
                    if (!newValues.includes(value)) newValues.push(value);
                }
            } else {
                newValues = newValues.filter((v) => v !== value);
            }

            return { ...prev, [name]: newValues };
        });
    };

    return (
        <div className="container">
            <div className="wrap">
                <SideMenu menu={MENU_PAYMENT} />
                <div className="email-request-list-content content-right things-to-checkList">
                    <h1 className="title title-email-request-list">DVmall 사은품 교환목록</h1>
                    <div id="search-box">
                        <table className="table-gray">
                            <tbody>
                                <tr>
                                    <th>교육명 검색</th>
                                    <td>
                                        <div className="flex-conditional-search">
                                            <div className="select-box">
                                                <select onChange={getSearchCondition} value={searchCondition}>
                                                    <option value="DE_MemberID">덴탈 비타민 ID</option>
                                                    <option value="EM_MemberID">Dvmall ID</option>
                                                    <option value="NameKor">이름</option>
                                                    <option value="CouponNum">쿠폰번호</option>
                                                    <option value="GoodName">결제 상품명</option>
                                                </select>
                                                <input
                                                    type="text"
                                                    placeholder="검색어 입력"
                                                    value={keyword}
                                                    onChange={inputChange}
                                                />
                                            </div>
                                        </div>
                                    </td>
                                    <th style={{ borderBottom: '1px solid #ddd' }}>사용여부</th>
                                    <td>
                                        <div className="flex-CheckGroup">
                                            <CheckGroup
                                                name="IsUsed"
                                                options={[
                                                    { id: 'memberGbn_All', value: 'ALL', label: '전체' },
                                                    { id: 'memberGbn_Y', value: 'Y', label: '사용' },
                                                    { id: 'memberGbn_N', value: 'N', label: '미사용' },
                                                ]}
                                                checkedValues={checkedValues.IsUsed}
                                                onChange={handleCheckboxChange}
                                                type="checkbox"
                                            />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th>등록일</th>
                                    <td colSpan={3}>
                                        <div className="flex group-item">
                                            <div className="group-datepicker">
                                                <div className="datepicker-child">
                                                    <DatePicker
                                                        ref={startDateRef}
                                                        onChange={(date) => handleDateChange(date, 'startDate')}
                                                        locale={'ko'}
                                                        placeholderText={'YYYY/MM/DD'}
                                                        dateFormat={'yyyy/MM/dd'}
                                                        selected={startDate}
                                                        maxDate={endDate || null}
                                                    />
                                                    <i
                                                        className="icon icon-date"
                                                        id="start-date-icon"
                                                        onClick={() => startDateRef.current.setFocus()}
                                                    />
                                                </div>
                                                <span>~</span>
                                                <div className="datepicker-child">
                                                    <DatePicker
                                                        ref={endDateRef}
                                                        onChange={(date) => handleDateChange(date, 'endDate')}
                                                        locale={'ko'}
                                                        placeholderText={'YYYY/MM/DD'}
                                                        dateFormat={'yyyy/MM/dd'}
                                                        selected={endDate}
                                                        minDate={startDate || null}
                                                    />
                                                    <i
                                                        className="icon icon-date"
                                                        id="end-date-icon"
                                                        onClick={() => endDateRef.current.setFocus()}
                                                    />
                                                </div>
                                            </div>
                                            <ul className="select-value">
                                                <li
                                                    value-date-range="today"
                                                    className={dateRate === 'today' ? 'active' : ''}
                                                    onClick={handleDateRange}
                                                >
                                                    오늘
                                                </li>
                                                <li
                                                    value-date-range="1week"
                                                    className={dateRate === '1week' ? 'active' : ''}
                                                    onClick={handleDateRange}
                                                >
                                                    일주일
                                                </li>
                                                <li
                                                    value-date-range="15days"
                                                    className={dateRate === '15days' ? 'active' : ''}
                                                    onClick={handleDateRange}
                                                >
                                                    15일
                                                </li>
                                                <li
                                                    value-date-range="1month"
                                                    className={dateRate === '1month' ? 'active' : ''}
                                                    onClick={handleDateRange}
                                                >
                                                    1개월
                                                </li>
                                                <li
                                                    value-date-range="3months"
                                                    className={dateRate === '3months' ? 'active' : ''}
                                                    onClick={handleDateRange}
                                                >
                                                    3개월
                                                </li>
                                            </ul>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div className="group-button center">
                            <button className="btn btn-gray-bold" onClick={clickSearch}>
                                검색
                            </button>
                            <button className="btn btn-gray-thin" onClick={clickReset}>
                                초기화
                            </button>
                        </div>
                    </div>

                    {/* <div className="group-coupon">
                        <div className="item-coupon">
                            <div className="title-coupon blueText">※ 발급쿠폰 : KF94 교환쿠폰</div>
                            <div className="table-coupon">
                                <table>
                                    <tbody>
                                        <tr>
                                            <td>급일 발급</td>
                                            <td>금일 사용가능</td>
                                            <td>금일 사용</td>
                                            <td>금일 발송</td>
                                            <td>금일 미사용</td>
                                            <td>
                                                금일 소멸
                                                <br />
                                                (삭제 포함)
                                            </td>
                                        </tr>
                                        <tr>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td>누적 발급</td>
                                            <td>누적 사용가능</td>
                                            <td>누적 사용</td>
                                            <td>누적 발송</td>
                                            <td>누적 미사용</td>
                                            <td>
                                                누적 소멸
                                                <br />
                                                (삭제포함)
                                            </td>
                                        </tr>
                                        <tr>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="item-coupon">
                            <div className="title-coupon blueText">※ 발급쿠폰 : Coffee 교환쿠폰</div>
                            <div className="table-coupon">
                                <table>
                                    <tbody>
                                        <tr>
                                            <td>급일 발급</td>
                                            <td>금일 사용가능</td>
                                            <td>금일 사용</td>
                                            <td>금일 발송</td>
                                            <td>금일 미사용</td>
                                            <td>
                                                금일 소멸
                                                <br />
                                                (삭제 포함)
                                            </td>
                                        </tr>
                                        <tr>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td>누적 발급</td>
                                            <td>누적 사용가능</td>
                                            <td>누적 사용</td>
                                            <td>누적 발송</td>
                                            <td>누적 미사용</td>
                                            <td>
                                                누적 소멸
                                                <br />
                                                (삭제포함)
                                            </td>
                                        </tr>
                                        <tr>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div> */}
                    <div className="results">
                        <div className="flex-top-item">
                            <div className="count-item">
                                총 <span className="total">{formatNumberWithCommas(pages?.totalRow || 0)}</span>건
                            </div>
                            <div className="group-button">
                                <div className="select-box select-box-coupon">
                                    <select onChange={handleYearChange} value={selectedYear}>
                                        {years.map((year) => (
                                            <option key={year} value={year}>
                                                {year}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="select-box select-box-coupon">
                                    <select onChange={handleMonthChange} value={selectedMonth}>
                                        {Array.from({ length: 12 }, (_, i) => i + 1).map((month) => (
                                            <option key={month} value={month}>
                                                {month}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <button
                                    className="btn btn-gray-bold btn-gray-bold-coupon"
                                    onClick={onDownload}
                                    disabled={isDownloading}
                                >
                                    {isDownloading ? '다운로드 중...' : '교환쿠폰 발급현황'}
                                </button>
                            </div>
                        </div>
                        <table className="table-gray table-gray-coupon">
                            <thead>
                                <tr>
                                    <th />
                                    <th>덴탈비타민 ID</th>
                                    <th>이름</th>
                                    <th style={{ width: '110px' }}>덴탈이마트 ID</th>
                                    <th style={{ width: '80px' }}>발급쿠폰</th>
                                    <th>쿠폰번호</th>
                                    <th style={{ width: '70px' }}>
                                        발급
                                        <br />
                                        사이트
                                    </th>
                                    <th>
                                        상품명
                                        <br />
                                        결제방법
                                    </th>
                                    <th>
                                        발급일자
                                        <br />
                                        유효기간
                                    </th>
                                    <th style={{ width: '80px' }}>
                                        사용여부
                                        <br />
                                        사용일자
                                    </th>
                                    <th style={{ width: '80px' }}>
                                        발송완료
                                        <br />
                                        발송일시
                                    </th>
                                    <th style={{ width: '70px' }}>상태</th>
                                    <th>쿠폰삭제</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data && data.length > 0 ? (
                                    data.map((item) => (
                                        <tr key={item.seq}>
                                            <td>{item.seq}</td>
                                            <td>{item.deMemberID}</td>
                                            <td>{item.nameKor}</td>
                                            <td>{item.deMemberID}</td>
                                            <td>{item.couponName}</td>
                                            <td>{item.couponNum}</td>
                                            <td>{item.regPos}</td>
                                            <td>{item.goodName}</td>
                                            <td>
                                                {formatDate(item.regDate)}
                                                <br />
                                                {formatDate(item.expiryDate)}
                                            </td>
                                            <td>
                                                {item.isUsed === 'Y' ? (
                                                    <>
                                                        사용 <br />
                                                        {formatDate(item.useDate)}
                                                    </>
                                                ) : (
                                                    '미사용'
                                                )}
                                            </td>
                                            <td>{item.isSend === 'Y' && `발송완료 ${formatDate(item.sendDate)}`}</td>
                                            <td></td>
                                            <td>
                                                {item.isUsed === 'N' && (
                                                    <button
                                                        className="btn-delete-coupon"
                                                        onClick={() => handleDelete(item?.deMemberID, item?.couponNum)}
                                                    >
                                                        쿠폰삭제
                                                    </button>
                                                )}
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={13}>데이타가 없습니다.</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                        <Pagination pages={pages} />
                    </div>
                </div>
            </div>
        </div>
    );
};
export default MAIAB010;
